import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { BottomStripe } from '../../components/Footer/components/BottomStripe/index.js';
import { Container } from '../../components/Footer/components/Container.js';
import { Legal } from '../../components/Footer/components/Legal.js';
import { Links } from '../../components/Footer/components/Links/index.js';
import { SocialLinks } from '../../components/Footer/components/SocialLinks/index.js';
import { FOOTER_QA_ID, qaId } from '../../utils/qaId.js';
export const Full = ({
  links,
  socialLinks,
  path = '',
  showTrustElement = false,
  brandName = 'ab in den urlaub'
}) => {
  const {
    t
  } = useTranslation(['footer']);
  return _jsxs(Container, {
    "data-testid": qaId(FOOTER_QA_ID),
    children: [_jsx(Links, {
      links: links,
      path: path,
      showTrustElement: showTrustElement,
      brandName: brandName
    }), _jsxs(BottomStripe, {
      children: [_jsx(Legal, {
        "data-testid": qaId(FOOTER_QA_ID, 'title', 'copyright'),
        children: brandName === 'invia.cz' ? _jsxs("span", {
          children: ["\u00A9 2000-", new Date().getFullYear(), ". ", brandName, ", a.s.- nejv\u011Bt\u0161\u00ED cestovn\u00ED agentura v \u010CR. Najdete n\u00E1s na", ' ', _jsx("a", {
            href: "https://www.invia.sk",
            children: "Invia.sk"
          }), ",", _jsx("a", {
            href: "https://www.invia.hu",
            children: " Invia.hu"
          }), " a", _jsx("a", {
            href: "https://www.travelplanet.pl",
            children: " Travelplanet.pl"
          }), ". Tato str\u00E1nka vyu\u017E\u00EDv\u00E1 cookies"]
        }) : _jsxs(_Fragment, {
          children: [t('copyright', {
            brandName: brandName,
            year: new Date().getFullYear()
          }), _jsx("br", {}), t('allRightsReserved')]
        })
      }), _jsx(SocialLinks, {
        links: socialLinks
      })]
    })]
  });
};